/** Bridges "Customize dashboard" (last column) and the toolbox panel without AngularJS `$rootScope` broadcasts. */

export class DashSectionToolboxBridge {
    private static readonly openSubscribers = new Set<() => void>();

    static subscribeOpen(handler: () => void): () => void {
        DashSectionToolboxBridge.openSubscribers.add(handler);
        return () => DashSectionToolboxBridge.openSubscribers.delete(handler);
    }

    static emitOpen(): void {
        for (const handler of DashSectionToolboxBridge.openSubscribers) {
            handler();
        }
    }
}
